import React from "react";
import ContentListGrid from "../components/ContentListGrid";
import PublicPageSettings from "../components/PublicPageSettings";
import { COLLECTIONS } from "../utils/cmsSchema";

export default function NewsList() {
  return (
    <div>
      <PublicPageSettings
        collectionKey="news"
        publicPath="/news"
        defaultHeading="News"
        defaultSubheading=""
      />
      <ContentListGrid
        schema={COLLECTIONS.news}
        title="News"
        subtitle="Press releases and announcements shown on /news."
        newRoute="/cms/news/new"
        metaFor={(d) => d.author || ""}
      />
    </div>
  );
}
